import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModalController, MODAL_CONTROLLER, MODAL_DATA } from 'shared';
import { EnergyDashboardSettingsDto } from '../../../interfaces/installation';
import { UserTrackingHelperService } from '../../../services/user-tracking-helper.service';
import { ModalComponent } from '../../../../../../shared/src/lib/components/modal/modal.component';
import { ModalContentComponent } from '../../../../../../shared/src/lib/components/modal-content/modal-content.component';
import { ModalSectionComponent } from '../../../../../../shared/src/lib/components/modal-section/modal-section.component';
import { ModalSectionColumnComponent } from '../../../../../../shared/src/lib/components/modal-section-column/modal-section-column.component';
import { InputLabelComponent } from '../../../../../../shared/src/lib/components/input-label/input-label.component';
import { InputFieldComponent } from '../../../../../../shared/src/lib/components/input-field/input-field.component';
import { AsyncPipe } from '@angular/common';
import { ModalButtonsComponent } from '../../../../../../shared/src/lib/components/modal-buttons/modal-buttons.component';
import { ModalButtonComponent } from '../../../../../../shared/src/lib/components/modal-button/modal-button.component';
import { Angulartics2OnModule } from 'angulartics2';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-energy-management-dashboard-settings-modal',
    templateUrl: './energy-management-dashboard-settings-modal.component.html',
    styleUrls: ['./energy-management-dashboard-settings-modal.component.scss'],
    imports: [ModalComponent, ModalContentComponent, FormsModule, ReactiveFormsModule, ModalSectionComponent, ModalSectionColumnComponent, InputLabelComponent, InputFieldComponent, ModalButtonsComponent, ModalButtonComponent, Angulartics2OnModule, TranslateModule, AsyncPipe]
})
export class EnergyManagementDashboardSettingsModalComponent implements OnInit, OnDestroy {

  private subscription = new Subscription();
  public form: UntypedFormGroup;
  public isValid$: Observable<boolean>;
  public title: string;

  constructor(
    @Inject(MODAL_DATA) public data: EnergyDashboardSettingsDto,
    @Inject(MODAL_CONTROLLER) private controller: ModalController<EnergyDashboardSettingsDto>,
    private userTrackingHelperService: UserTrackingHelperService
  ) {}

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      emissionFactor: new UntypedFormControl(this.data.emissionFactor, [Validators.min(0)]),
      suppliedArea: new UntypedFormControl(this.data.suppliedArea, [Validators.min(0)]),
      lastYearDeltaT: new UntypedFormControl(this.data.lastYearDeltaT, [Validators.min(0)]),
      lastYearEnergyConsumption: new UntypedFormControl(this.data.lastYearEnergyConsumption, [Validators.min(0)]),
      deltaTPenaltyFactor: new UntypedFormControl(this.data.deltaTPenaltyFactor, [Validators.min(0)]),
    });

    if (this.data.showTankVolume) {
      this.form.addControl("tankVolume", new UntypedFormControl(this.data.tankVolume, [Validators.min(0)]));
    }

    this.subscription.add(this.userTrackingHelperService.startFormValueChangeTracking('edbSettingsClicked', this.form));

    this.isValid$ = this.form.valueChanges.pipe(
      map(value => {
        return this.form.valid;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  close() {
    this.controller.dismiss();
  }

  save() {
    this.controller.complete({
      ...this.form.value
    });
  }

  dismiss() {
    this.userTrackingHelperService.trackUserAction('edbSettingsClicked', 'exitClicked');
  }
}
